import React from 'react';
import PropTypes from 'prop-types';
import { useAnalyticsPageView } from "sdk/custom-hooks";
import CourseList from './CourseList';

function Courses(props) {
    const { history } = props;
    //analytic
    useAnalyticsPageView();

    function gotoPage() {
        history.push('/tests');
    }

    return (
        <CourseList
            handleTabChange={() => gotoPage()}
            showFooter={true}
        />
    );
}

Courses.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired
};

export default Courses;